var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_2005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4951 40C31.5408 40 40.4951 31.0457 40.4951 20C40.4951 8.9543 31.5408 0 20.4951 0C9.44942 0 0.495117 8.9543 0.495117 20C0.495117 31.0457 9.44942 40 20.4951 40Z",
    fill: "#1E96C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0617 11.1125C30.0887 11.0944 30.6663 10.8327 31.1807 11.1756C31.5778 11.4464 31.7673 11.9608 31.6319 12.4571C30.3775 18.377 29.1141 24.297 27.8597 30.2169C27.8507 30.2891 27.7785 30.8576 27.2641 31.1644C26.9212 31.372 26.4881 31.3991 26.109 31.2366C26.0098 31.1915 25.9105 31.1284 25.8203 31.0652C22.8422 28.8272 19.8642 26.5891 16.8862 24.3421L27.2732 15.0019C27.3002 14.9568 27.4176 14.8124 27.3724 14.7222C27.3363 14.65 27.21 14.6229 27.0385 14.65C26.8761 14.668 26.7227 14.7312 26.5873 14.8215C22.3188 17.5107 18.0594 20.1999 13.7909 22.8892L7.98826 21.1294C7.74461 20.949 7.40168 20.6602 7.42876 20.3173C7.45583 20.0014 7.78973 19.7848 7.91607 19.7036C8.96289 19.0539 25.9015 12.6737 30.0617 11.1125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8864 24.3511L16.5164 30.0905C16.6517 30.0815 16.8503 30.0634 17.0759 29.9642C17.3466 29.8469 17.5271 29.6754 17.6263 29.5671C18.5197 28.6827 19.4132 27.7984 20.3066 26.914L16.8864 24.3511Z",
    fill: "#A9C9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5071 30.0904C16.3537 30.0904 16.1732 30.0634 16.0288 29.9461C15.8573 29.8017 15.8032 29.5941 15.7942 29.54C15.6949 29.1339 14.9008 26.5078 13.7908 22.8981L26.5872 14.8304C26.6414 14.7943 26.7136 14.7492 26.8128 14.7131C26.9753 14.6499 27.2821 14.5777 27.3633 14.695C27.3994 14.7401 27.3814 14.8123 27.3723 14.8394C27.3723 14.8394 27.3543 14.9296 27.2731 15.0109C27.1648 15.1192 22.8151 19.0267 16.8861 24.351L16.5071 30.0904Z",
    fill: "#C8DAEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_2005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.495117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.bd93a958bf79becaa46a99d0701284c8.svg";
export { ForwardRef as ReactComponent };